/* src/app/manage-users/manage-users-bulk-update-presenter/manage-users-bulk-update-presenter.component.scss */
/*# sourceMappingURL=manage-users-bulk-update-presenter.component.css.map */
